{
  "blue": {
    "id": "blue",
    "name": "BLUE INFILTRATOR",
    "category": "INFANTRY",
    "defaultEnvironment": "ground",
    "allowedEnvironments": [
      "ground"
    ],
    "allowedStances": [
      "stand"
    ],
    "worldSize": 7.0,
    "dimension": {
      "widthMeters": 1.07,
      "heightMeters": 1.26,
      "depthMeters": 0.2
    },
    "sourceTag": "ESOTERIA/SPRITES.E3 : blue.e3 (world_size: 7.0)",
    "numAngles": 8,
    "tracks": {
      "stand:idle": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 4.0,
        "stance": "stand",
        "action": "idle",
        "description": "STAND IDLE"
      },
      "stand:walk": {
        "sectionIndex": 1,
        "frameCount": 8,
        "fps": 8.0,
        "stance": "stand",
        "action": "walk",
        "description": "STAND WALK"
      },
      "stand:run": {
        "sectionIndex": 1,
        "frameCount": 8,
        "fps": 8.0,
        "stance": "stand",
        "action": "run",
        "description": "STAND RUN"
      },
      "stand:attack": {
        "sectionIndex": 9,
        "frameCount": 1,
        "fps": 8.0,
        "stance": "stand",
        "action": "attack",
        "description": "STAND ATTACK"
      },
      "stand:hurt": {
        "sectionIndex": 10,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "hurt",
        "description": "STAND HURT"
      },
      "stand:death": {
        "sectionIndex": 10,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "death",
        "description": "STAND DEATH"
      }
    }
  },
  "carrier": {
    "id": "carrier",
    "name": "AUTOMATED VEHICLE CARRIER",
    "category": "HEAVY",
    "defaultEnvironment": "ground",
    "allowedEnvironments": [
      "ground"
    ],
    "allowedStances": [
      "stand"
    ],
    "worldSize": 6.5,
    "dimension": {
      "widthMeters": 1.87,
      "heightMeters": 2.2,
      "depthMeters": 0.2
    },
    "sourceTag": "ESOTERIA/SPRITES.E3 : carrier.e3 (world_size: 6.5)",
    "numAngles": 8,
    "tracks": {
      "stand:idle": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 4.0,
        "stance": "stand",
        "action": "idle",
        "description": "STAND IDLE"
      },
      "stand:walk": {
        "sectionIndex": 1,
        "frameCount": 8,
        "fps": 8.0,
        "stance": "stand",
        "action": "walk",
        "description": "STAND WALK"
      },
      "stand:run": {
        "sectionIndex": 1,
        "frameCount": 8,
        "fps": 8.0,
        "stance": "stand",
        "action": "run",
        "description": "STAND RUN"
      },
      "stand:attack": {
        "sectionIndex": 9,
        "frameCount": 2,
        "fps": 8.0,
        "stance": "stand",
        "action": "attack",
        "description": "STAND ATTACK"
      },
      "stand:hurt": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 4.0,
        "stance": "stand",
        "action": "hurt",
        "description": "STAND HURT"
      },
      "stand:death": {
        "sectionIndex": 9,
        "frameCount": 2,
        "fps": 6.0,
        "stance": "stand",
        "action": "death",
        "description": "STAND DEATH"
      }
    }
  },
  "constbot": {
    "id": "constbot",
    "name": "CONSTRUCTION SECURITY BOT",
    "category": "HEAVY",
    "defaultEnvironment": "ground",
    "allowedEnvironments": [
      "ground"
    ],
    "allowedStances": [
      "stand"
    ],
    "worldSize": 10.0,
    "dimension": {
      "widthMeters": 1.87,
      "heightMeters": 2.2,
      "depthMeters": 0.2
    },
    "sourceTag": "ESOTERIA/SPRITES.E3 : constbot.e3 (world_size: 10.0)",
    "numAngles": 8,
    "tracks": {
      "stand:idle": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 4.0,
        "stance": "stand",
        "action": "idle",
        "description": "STAND IDLE"
      },
      "stand:walk": {
        "sectionIndex": 1,
        "frameCount": 8,
        "fps": 8.0,
        "stance": "stand",
        "action": "walk",
        "description": "STAND WALK"
      },
      "stand:run": {
        "sectionIndex": 1,
        "frameCount": 8,
        "fps": 8.0,
        "stance": "stand",
        "action": "run",
        "description": "STAND RUN"
      },
      "stand:attack": {
        "sectionIndex": 9,
        "frameCount": 4,
        "fps": 8.0,
        "stance": "stand",
        "action": "attack",
        "description": "STAND ATTACK"
      },
      "stand:hurt": {
        "sectionIndex": 13,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "hurt",
        "description": "STAND HURT"
      },
      "stand:death": {
        "sectionIndex": 18,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "death",
        "description": "STAND DEATH"
      }
    }
  },
  "crimson": {
    "id": "crimson",
    "name": "CRIMSON SIEGE ENFORCER",
    "category": "HEAVY",
    "defaultEnvironment": "ground",
    "allowedEnvironments": [
      "ground"
    ],
    "allowedStances": [
      "stand"
    ],
    "worldSize": 9.0,
    "dimension": {
      "widthMeters": 1.87,
      "heightMeters": 2.2,
      "depthMeters": 0.2
    },
    "sourceTag": "ESOTERIA/SPRITES.E3 : crimson.e3 (world_size: 9.0)",
    "numAngles": 8,
    "tracks": {
      "stand:idle": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 4.0,
        "stance": "stand",
        "action": "idle",
        "description": "STAND IDLE"
      },
      "stand:walk": {
        "sectionIndex": 1,
        "frameCount": 8,
        "fps": 8.0,
        "stance": "stand",
        "action": "walk",
        "description": "STAND WALK"
      },
      "stand:run": {
        "sectionIndex": 1,
        "frameCount": 8,
        "fps": 8.0,
        "stance": "stand",
        "action": "run",
        "description": "STAND RUN"
      },
      "stand:attack": {
        "sectionIndex": 9,
        "frameCount": 1,
        "fps": 8.0,
        "stance": "stand",
        "action": "attack",
        "description": "STAND ATTACK"
      },
      "stand:hurt": {
        "sectionIndex": 10,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "hurt",
        "description": "STAND HURT"
      },
      "stand:death": {
        "sectionIndex": 11,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "death",
        "description": "STAND DEATH"
      }
    }
  },
  "derby": {
    "id": "derby",
    "name": "DERBY RECON COMBATANT",
    "category": "INFANTRY",
    "defaultEnvironment": "ground",
    "allowedEnvironments": [
      "ground"
    ],
    "allowedStances": [
      "stand"
    ],
    "worldSize": 7.0,
    "dimension": {
      "widthMeters": 1.07,
      "heightMeters": 1.26,
      "depthMeters": 0.2
    },
    "sourceTag": "ESOTERIA/SPRITES.E3 : derby.e3 (world_size: 7.0)",
    "numAngles": 8,
    "tracks": {
      "stand:idle": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 4.0,
        "stance": "stand",
        "action": "idle",
        "description": "STAND IDLE"
      },
      "stand:walk": {
        "sectionIndex": 1,
        "frameCount": 4,
        "fps": 8.0,
        "stance": "stand",
        "action": "walk",
        "description": "STAND WALK"
      },
      "stand:run": {
        "sectionIndex": 1,
        "frameCount": 4,
        "fps": 8.0,
        "stance": "stand",
        "action": "run",
        "description": "STAND RUN"
      },
      "stand:attack": {
        "sectionIndex": 1,
        "frameCount": 4,
        "fps": 8.0,
        "stance": "stand",
        "action": "attack",
        "description": "STAND ATTACK"
      },
      "stand:hurt": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 4.0,
        "stance": "stand",
        "action": "hurt",
        "description": "STAND HURT"
      },
      "stand:death": {
        "sectionIndex": 1,
        "frameCount": 4,
        "fps": 6.0,
        "stance": "stand",
        "action": "death",
        "description": "STAND DEATH"
      }
    }
  },
  "dropship": {
    "id": "dropship",
    "name": "TACTICAL AIRBORNE DROPSHIP",
    "category": "AERIAL",
    "defaultEnvironment": "air",
    "allowedEnvironments": [
      "air",
      "ground"
    ],
    "allowedStances": [
      "stand"
    ],
    "worldSize": 10.0,
    "dimension": {
      "widthMeters": 1.87,
      "heightMeters": 2.2,
      "depthMeters": 0.2
    },
    "sourceTag": "ESOTERIA/SPRITES.E3 : dropship.e3 (world_size: 10.0)",
    "numAngles": 8,
    "tracks": {
      "stand:idle": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 4.0,
        "stance": "stand",
        "action": "idle",
        "description": "STAND IDLE"
      },
      "stand:walk": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "walk",
        "description": "STAND WALK"
      },
      "stand:run": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "run",
        "description": "STAND RUN"
      },
      "stand:attack": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "attack",
        "description": "STAND ATTACK"
      },
      "stand:hurt": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 4.0,
        "stance": "stand",
        "action": "hurt",
        "description": "STAND HURT"
      },
      "stand:death": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "death",
        "description": "STAND DEATH"
      }
    }
  },
  "drrobo": {
    "id": "drrobo",
    "name": "DR. ROBO CYBERNETIC MECH",
    "category": "BOSS",
    "defaultEnvironment": "ground",
    "allowedEnvironments": [
      "ground"
    ],
    "allowedStances": [
      "stand"
    ],
    "worldSize": 20.0,
    "dimension": {
      "widthMeters": 3.4,
      "heightMeters": 4.0,
      "depthMeters": 0.2
    },
    "sourceTag": "ESOTERIA/SPRITES.E3 : drrobo.e3 (world_size: 20.0)",
    "numAngles": 8,
    "tracks": {
      "stand:idle": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 4.0,
        "stance": "stand",
        "action": "idle",
        "description": "STAND IDLE"
      },
      "stand:walk": {
        "sectionIndex": 1,
        "frameCount": 8,
        "fps": 8.0,
        "stance": "stand",
        "action": "walk",
        "description": "STAND WALK"
      },
      "stand:run": {
        "sectionIndex": 1,
        "frameCount": 8,
        "fps": 8.0,
        "stance": "stand",
        "action": "run",
        "description": "STAND RUN"
      },
      "stand:attack": {
        "sectionIndex": 9,
        "frameCount": 4,
        "fps": 8.0,
        "stance": "stand",
        "action": "attack",
        "description": "STAND ATTACK"
      },
      "stand:hurt": {
        "sectionIndex": 13,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "hurt",
        "description": "STAND HURT"
      },
      "stand:death": {
        "sectionIndex": 14,
        "frameCount": 4,
        "fps": 6.0,
        "stance": "stand",
        "action": "death",
        "description": "STAND DEATH"
      }
    }
  },
  "eel": {
    "id": "eel",
    "name": "ELECTRIC VOLTAIC EEL",
    "category": "AQUATIC",
    "defaultEnvironment": "water",
    "allowedEnvironments": [
      "water"
    ],
    "allowedStances": [
      "stand"
    ],
    "worldSize": 8.0,
    "dimension": {
      "widthMeters": 1.02,
      "heightMeters": 1.2,
      "depthMeters": 0.2
    },
    "sourceTag": "ESOTERIA/SPRITES.E3 : eel.e3 (world_size: 8.0)",
    "numAngles": 8,
    "tracks": {
      "stand:idle": {
        "sectionIndex": 0,
        "frameCount": 4,
        "fps": 4.0,
        "stance": "stand",
        "action": "idle",
        "description": "STAND IDLE"
      },
      "stand:walk": {
        "sectionIndex": 4,
        "frameCount": 4,
        "fps": 8.0,
        "stance": "stand",
        "action": "walk",
        "description": "STAND WALK"
      },
      "stand:run": {
        "sectionIndex": 4,
        "frameCount": 4,
        "fps": 8.0,
        "stance": "stand",
        "action": "run",
        "description": "STAND RUN"
      },
      "stand:attack": {
        "sectionIndex": 4,
        "frameCount": 4,
        "fps": 8.0,
        "stance": "stand",
        "action": "attack",
        "description": "STAND ATTACK"
      },
      "stand:hurt": {
        "sectionIndex": 0,
        "frameCount": 4,
        "fps": 4.0,
        "stance": "stand",
        "action": "hurt",
        "description": "STAND HURT"
      },
      "stand:death": {
        "sectionIndex": 4,
        "frameCount": 4,
        "fps": 6.0,
        "stance": "stand",
        "action": "death",
        "description": "STAND DEATH"
      }
    }
  },
  "fbot": {
    "id": "fbot",
    "name": "FBOT FLYING ASSAULT MECH",
    "category": "AERIAL",
    "defaultEnvironment": "air",
    "allowedEnvironments": [
      "air",
      "ground"
    ],
    "allowedStances": [
      "stand"
    ],
    "worldSize": 20.0,
    "dimension": {
      "widthMeters": 3.4,
      "heightMeters": 4.0,
      "depthMeters": 0.2
    },
    "sourceTag": "ESOTERIA/SPRITES.E3 : fbot.e3 (world_size: 20.0)",
    "numAngles": 8,
    "tracks": {
      "stand:idle": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 4.0,
        "stance": "stand",
        "action": "idle",
        "description": "STAND IDLE"
      },
      "stand:walk": {
        "sectionIndex": 1,
        "frameCount": 8,
        "fps": 8.0,
        "stance": "stand",
        "action": "walk",
        "description": "STAND WALK"
      },
      "stand:run": {
        "sectionIndex": 1,
        "frameCount": 8,
        "fps": 8.0,
        "stance": "stand",
        "action": "run",
        "description": "STAND RUN"
      },
      "stand:attack": {
        "sectionIndex": 9,
        "frameCount": 6,
        "fps": 8.0,
        "stance": "stand",
        "action": "attack",
        "description": "STAND ATTACK"
      },
      "stand:hurt": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 4.0,
        "stance": "stand",
        "action": "hurt",
        "description": "STAND HURT"
      },
      "stand:death": {
        "sectionIndex": 9,
        "frameCount": 6,
        "fps": 6.0,
        "stance": "stand",
        "action": "death",
        "description": "STAND DEATH"
      }
    }
  },
  "fire": {
    "id": "fire",
    "name": "PYRO KINETIC WISP",
    "category": "AERIAL",
    "defaultEnvironment": "air",
    "allowedEnvironments": [
      "air",
      "ground"
    ],
    "allowedStances": [
      "stand"
    ],
    "worldSize": 6.0,
    "dimension": {
      "widthMeters": 0.77,
      "heightMeters": 0.9,
      "depthMeters": 0.2
    },
    "sourceTag": "ESOTERIA/SPRITES.E3 : fire.e3 (world_size: 6.0)",
    "numAngles": 8,
    "tracks": {
      "stand:idle": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 4.0,
        "stance": "stand",
        "action": "idle",
        "description": "STAND IDLE"
      },
      "stand:walk": {
        "sectionIndex": 1,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "walk",
        "description": "STAND WALK"
      },
      "stand:attack": {
        "sectionIndex": 2,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "attack",
        "description": "STAND ATTACK"
      },
      "stand:hurt": {
        "sectionIndex": 3,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "hurt",
        "description": "STAND HURT"
      },
      "stand:death": {
        "sectionIndex": 4,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "death",
        "description": "STAND DEATH"
      }
    }
  },
  "fish": {
    "id": "fish",
    "name": "MUTATED NATIVE FAUNA",
    "category": "AQUATIC",
    "defaultEnvironment": "water",
    "allowedEnvironments": [
      "water"
    ],
    "allowedStances": [
      "stand"
    ],
    "worldSize": 1.0,
    "dimension": {
      "widthMeters": 0.77,
      "heightMeters": 0.9,
      "depthMeters": 0.2
    },
    "sourceTag": "ESOTERIA/SPRITES.E3 : fish.e3 (world_size: 1.0)",
    "numAngles": 8,
    "tracks": {
      "stand:idle": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 4.0,
        "stance": "stand",
        "action": "idle",
        "description": "STAND IDLE"
      },
      "stand:walk": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "walk",
        "description": "STAND WALK"
      },
      "stand:run": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "run",
        "description": "STAND RUN"
      },
      "stand:attack": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "attack",
        "description": "STAND ATTACK"
      },
      "stand:hurt": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 4.0,
        "stance": "stand",
        "action": "hurt",
        "description": "STAND HURT"
      },
      "stand:death": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "death",
        "description": "STAND DEATH"
      }
    }
  },
  "guardian": {
    "id": "guardian",
    "name": "GUARDIAN BIPEDAL WAR MECH",
    "category": "HEAVY",
    "defaultEnvironment": "ground",
    "allowedEnvironments": [
      "ground"
    ],
    "allowedStances": [
      "stand"
    ],
    "worldSize": 12.0,
    "dimension": {
      "widthMeters": 2.04,
      "heightMeters": 2.4,
      "depthMeters": 0.2
    },
    "sourceTag": "ESOTERIA/SPRITES.E3 : guardian.e3 (world_size: 12.0)",
    "numAngles": 8,
    "tracks": {
      "stand:idle": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 4.0,
        "stance": "stand",
        "action": "idle",
        "description": "STAND IDLE"
      },
      "stand:walk": {
        "sectionIndex": 1,
        "frameCount": 8,
        "fps": 8.0,
        "stance": "stand",
        "action": "walk",
        "description": "STAND WALK"
      },
      "stand:run": {
        "sectionIndex": 1,
        "frameCount": 8,
        "fps": 8.0,
        "stance": "stand",
        "action": "run",
        "description": "STAND RUN"
      },
      "stand:attack": {
        "sectionIndex": 9,
        "frameCount": 1,
        "fps": 8.0,
        "stance": "stand",
        "action": "attack",
        "description": "STAND ATTACK"
      },
      "stand:hurt": {
        "sectionIndex": 10,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "hurt",
        "description": "STAND HURT"
      },
      "stand:death": {
        "sectionIndex": 11,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "death",
        "description": "STAND DEATH"
      }
    }
  },
  "heli": {
    "id": "heli",
    "name": "TACTICAL ATTACK GUNSHIP",
    "category": "AERIAL",
    "defaultEnvironment": "air",
    "allowedEnvironments": [
      "air",
      "ground"
    ],
    "allowedStances": [
      "stand"
    ],
    "worldSize": 30.0,
    "dimension": {
      "widthMeters": 1.7,
      "heightMeters": 2.0,
      "depthMeters": 0.2
    },
    "sourceTag": "ESOTERIA/SPRITES.E3 : heli.e3 (world_size: 30.0)",
    "numAngles": 8,
    "tracks": {
      "stand:idle": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 4.0,
        "stance": "stand",
        "action": "idle",
        "description": "STAND IDLE"
      },
      "stand:walk": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "walk",
        "description": "STAND WALK"
      },
      "stand:run": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "run",
        "description": "STAND RUN"
      },
      "stand:attack": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "attack",
        "description": "STAND ATTACK"
      },
      "stand:hurt": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 4.0,
        "stance": "stand",
        "action": "hurt",
        "description": "STAND HURT"
      },
      "stand:death": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "death",
        "description": "STAND DEATH"
      }
    }
  },
  "j5": {
    "id": "j5",
    "name": "J5 UTILITY RECON BOT",
    "category": "AERIAL",
    "defaultEnvironment": "air",
    "allowedEnvironments": [
      "air",
      "ground"
    ],
    "allowedStances": [
      "stand"
    ],
    "worldSize": 4.0,
    "dimension": {
      "widthMeters": 0.77,
      "heightMeters": 0.9,
      "depthMeters": 0.2
    },
    "sourceTag": "ESOTERIA/SPRITES.E3 : j5.e3 (world_size: 4.0)",
    "numAngles": 8,
    "tracks": {
      "stand:idle": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 4.0,
        "stance": "stand",
        "action": "idle",
        "description": "STAND IDLE"
      },
      "stand:walk": {
        "sectionIndex": 1,
        "frameCount": 4,
        "fps": 8.0,
        "stance": "stand",
        "action": "walk",
        "description": "STAND WALK"
      },
      "stand:run": {
        "sectionIndex": 1,
        "frameCount": 4,
        "fps": 8.0,
        "stance": "stand",
        "action": "run",
        "description": "STAND RUN"
      },
      "stand:attack": {
        "sectionIndex": 5,
        "frameCount": 4,
        "fps": 8.0,
        "stance": "stand",
        "action": "attack",
        "description": "STAND ATTACK"
      },
      "stand:hurt": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 4.0,
        "stance": "stand",
        "action": "hurt",
        "description": "STAND HURT"
      },
      "stand:death": {
        "sectionIndex": 5,
        "frameCount": 4,
        "fps": 6.0,
        "stance": "stand",
        "action": "death",
        "description": "STAND DEATH"
      }
    }
  },
  "jbk": {
    "id": "jbk",
    "name": "JBK COMBAT FLYER",
    "category": "AERIAL",
    "defaultEnvironment": "air",
    "allowedEnvironments": [
      "air",
      "ground"
    ],
    "allowedStances": [
      "stand"
    ],
    "worldSize": 9.0,
    "dimension": {
      "widthMeters": 1.15,
      "heightMeters": 1.35,
      "depthMeters": 0.2
    },
    "sourceTag": "ESOTERIA/SPRITES.E3 : jbk.e3 (world_size: 9.0)",
    "numAngles": 8,
    "tracks": {
      "stand:idle": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 4.0,
        "stance": "stand",
        "action": "idle",
        "description": "STAND IDLE"
      },
      "stand:walk": {
        "sectionIndex": 1,
        "frameCount": 8,
        "fps": 8.0,
        "stance": "stand",
        "action": "walk",
        "description": "STAND WALK"
      },
      "stand:run": {
        "sectionIndex": 1,
        "frameCount": 8,
        "fps": 8.0,
        "stance": "stand",
        "action": "run",
        "description": "STAND RUN"
      },
      "stand:attack": {
        "sectionIndex": 9,
        "frameCount": 2,
        "fps": 8.0,
        "stance": "stand",
        "action": "attack",
        "description": "STAND ATTACK"
      },
      "stand:hurt": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 4.0,
        "stance": "stand",
        "action": "hurt",
        "description": "STAND HURT"
      },
      "stand:death": {
        "sectionIndex": 9,
        "frameCount": 2,
        "fps": 6.0,
        "stance": "stand",
        "action": "death",
        "description": "STAND DEATH"
      }
    }
  },
  "maqua": {
    "id": "maqua",
    "name": "MAQUA AQUATIC PREDATOR",
    "category": "AQUATIC",
    "defaultEnvironment": "water",
    "allowedEnvironments": [
      "water"
    ],
    "allowedStances": [
      "stand"
    ],
    "worldSize": 10.0,
    "dimension": {
      "widthMeters": 1.27,
      "heightMeters": 1.5,
      "depthMeters": 0.2
    },
    "sourceTag": "ESOTERIA/SPRITES.E3 : maqua.e3 (world_size: 10.0)",
    "numAngles": 8,
    "tracks": {
      "stand:idle": {
        "sectionIndex": 0,
        "frameCount": 4,
        "fps": 4.0,
        "stance": "stand",
        "action": "idle",
        "description": "STAND IDLE"
      },
      "stand:walk": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "walk",
        "description": "STAND WALK"
      },
      "stand:run": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "run",
        "description": "STAND RUN"
      },
      "stand:attack": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "attack",
        "description": "STAND ATTACK"
      },
      "stand:hurt": {
        "sectionIndex": 0,
        "frameCount": 4,
        "fps": 4.0,
        "stance": "stand",
        "action": "hurt",
        "description": "STAND HURT"
      },
      "stand:death": {
        "sectionIndex": 0,
        "frameCount": 4,
        "fps": 6.0,
        "stance": "stand",
        "action": "death",
        "description": "STAND DEATH"
      }
    }
  },
  "mp1": {
    "id": "mp1",
    "name": "MP1 PATROL TROOPER",
    "category": "INFANTRY",
    "defaultEnvironment": "ground",
    "allowedEnvironments": [
      "ground"
    ],
    "allowedStances": [
      "stand"
    ],
    "worldSize": 6.5,
    "dimension": {
      "widthMeters": 0.99,
      "heightMeters": 1.17,
      "depthMeters": 0.2
    },
    "sourceTag": "ESOTERIA/SPRITES.E3 : mp1.e3 (world_size: 6.5)",
    "numAngles": 8,
    "tracks": {
      "stand:idle": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 4.0,
        "stance": "stand",
        "action": "idle",
        "description": "STAND IDLE"
      },
      "stand:walk": {
        "sectionIndex": 1,
        "frameCount": 8,
        "fps": 8.0,
        "stance": "stand",
        "action": "walk",
        "description": "STAND WALK"
      },
      "stand:run": {
        "sectionIndex": 9,
        "frameCount": 8,
        "fps": 10.0,
        "stance": "stand",
        "action": "run",
        "description": "STAND RUN"
      },
      "stand:attack": {
        "sectionIndex": 17,
        "frameCount": 1,
        "fps": 8.0,
        "stance": "stand",
        "action": "attack",
        "description": "STAND ATTACK"
      },
      "stand:hurt": {
        "sectionIndex": 18,
        "frameCount": 2,
        "fps": 6.0,
        "stance": "stand",
        "action": "hurt",
        "description": "STAND HURT"
      },
      "stand:death": {
        "sectionIndex": 18,
        "frameCount": 2,
        "fps": 6.0,
        "stance": "stand",
        "action": "death",
        "description": "STAND DEATH"
      }
    }
  },
  "mp1red": {
    "id": "mp1red",
    "name": "MP1 RED VANGUARD",
    "category": "INFANTRY",
    "defaultEnvironment": "ground",
    "allowedEnvironments": [
      "ground"
    ],
    "allowedStances": [
      "stand"
    ],
    "worldSize": 6.5,
    "dimension": {
      "widthMeters": 0.99,
      "heightMeters": 1.17,
      "depthMeters": 0.2
    },
    "sourceTag": "ESOTERIA/SPRITES.E3 : mp1red.e3 (world_size: 6.5)",
    "numAngles": 8,
    "tracks": {
      "stand:idle": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 4.0,
        "stance": "stand",
        "action": "idle",
        "description": "STAND IDLE"
      },
      "stand:walk": {
        "sectionIndex": 1,
        "frameCount": 8,
        "fps": 8.0,
        "stance": "stand",
        "action": "walk",
        "description": "STAND WALK"
      },
      "stand:run": {
        "sectionIndex": 9,
        "frameCount": 8,
        "fps": 10.0,
        "stance": "stand",
        "action": "run",
        "description": "STAND RUN"
      },
      "stand:attack": {
        "sectionIndex": 17,
        "frameCount": 1,
        "fps": 8.0,
        "stance": "stand",
        "action": "attack",
        "description": "STAND ATTACK"
      },
      "stand:hurt": {
        "sectionIndex": 18,
        "frameCount": 2,
        "fps": 6.0,
        "stance": "stand",
        "action": "hurt",
        "description": "STAND HURT"
      },
      "stand:death": {
        "sectionIndex": 20,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "death",
        "description": "STAND DEATH"
      }
    }
  },
  "mp2": {
    "id": "mp2",
    "name": "MP2 ASSAULT TROOPER",
    "category": "INFANTRY",
    "defaultEnvironment": "ground",
    "allowedEnvironments": [
      "ground"
    ],
    "allowedStances": [
      "stand"
    ],
    "worldSize": 9.0,
    "dimension": {
      "widthMeters": 1.38,
      "heightMeters": 1.62,
      "depthMeters": 0.2
    },
    "sourceTag": "ESOTERIA/SPRITES.E3 : mp2.e3 (world_size: 9.0)",
    "numAngles": 8,
    "tracks": {
      "stand:idle": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 4.0,
        "stance": "stand",
        "action": "idle",
        "description": "STAND IDLE"
      },
      "stand:walk": {
        "sectionIndex": 1,
        "frameCount": 8,
        "fps": 8.0,
        "stance": "stand",
        "action": "walk",
        "description": "STAND WALK"
      },
      "stand:run": {
        "sectionIndex": 9,
        "frameCount": 5,
        "fps": 10.0,
        "stance": "stand",
        "action": "run",
        "description": "STAND RUN"
      },
      "stand:attack": {
        "sectionIndex": 14,
        "frameCount": 1,
        "fps": 8.0,
        "stance": "stand",
        "action": "attack",
        "description": "STAND ATTACK"
      },
      "stand:hurt": {
        "sectionIndex": 15,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "hurt",
        "description": "STAND HURT"
      },
      "stand:death": {
        "sectionIndex": 15,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "death",
        "description": "STAND DEATH"
      }
    }
  },
  "mp3": {
    "id": "mp3",
    "name": "MP3 COMMANDO TROOPER",
    "category": "INFANTRY",
    "defaultEnvironment": "ground",
    "allowedEnvironments": [
      "ground"
    ],
    "allowedStances": [
      "stand"
    ],
    "worldSize": 9.0,
    "dimension": {
      "widthMeters": 1.38,
      "heightMeters": 1.62,
      "depthMeters": 0.2
    },
    "sourceTag": "ESOTERIA/SPRITES.E3 : mp3.e3 (world_size: 9.0)",
    "numAngles": 8,
    "tracks": {
      "stand:idle": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 4.0,
        "stance": "stand",
        "action": "idle",
        "description": "STAND IDLE"
      },
      "stand:walk": {
        "sectionIndex": 1,
        "frameCount": 8,
        "fps": 8.0,
        "stance": "stand",
        "action": "walk",
        "description": "STAND WALK"
      },
      "stand:run": {
        "sectionIndex": 1,
        "frameCount": 8,
        "fps": 8.0,
        "stance": "stand",
        "action": "run",
        "description": "STAND RUN"
      },
      "stand:attack": {
        "sectionIndex": 9,
        "frameCount": 1,
        "fps": 8.0,
        "stance": "stand",
        "action": "attack",
        "description": "STAND ATTACK"
      },
      "stand:hurt": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 4.0,
        "stance": "stand",
        "action": "hurt",
        "description": "STAND HURT"
      },
      "stand:death": {
        "sectionIndex": 9,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "death",
        "description": "STAND DEATH"
      }
    }
  },
  "probe": {
    "id": "probe",
    "name": "OPTICAL RECON PROBE",
    "category": "AERIAL",
    "defaultEnvironment": "air",
    "allowedEnvironments": [
      "air",
      "ground"
    ],
    "allowedStances": [
      "stand"
    ],
    "worldSize": 2.0,
    "dimension": {
      "widthMeters": 0.77,
      "heightMeters": 0.9,
      "depthMeters": 0.2
    },
    "sourceTag": "ESOTERIA/SPRITES.E3 : probe.e3 (world_size: 2.0)",
    "numAngles": 8,
    "tracks": {
      "stand:idle": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 4.0,
        "stance": "stand",
        "action": "idle",
        "description": "STAND IDLE"
      },
      "stand:walk": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "walk",
        "description": "STAND WALK"
      },
      "stand:run": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "run",
        "description": "STAND RUN"
      },
      "stand:attack": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "attack",
        "description": "STAND ATTACK"
      },
      "stand:hurt": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 4.0,
        "stance": "stand",
        "action": "hurt",
        "description": "STAND HURT"
      },
      "stand:death": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "death",
        "description": "STAND DEATH"
      }
    }
  },
  "raven": {
    "id": "raven",
    "name": "RAVEN CYBORG ASSASSIN",
    "category": "CYBORG",
    "defaultEnvironment": "ground",
    "allowedEnvironments": [
      "ground",
      "water"
    ],
    "allowedStances": [
      "crouch",
      "stand",
      "swim"
    ],
    "worldSize": 6.5,
    "dimension": {
      "widthMeters": 0.99,
      "heightMeters": 1.17,
      "depthMeters": 0.2
    },
    "sourceTag": "ESOTERIA/SPRITES.E3 : raven.e3 (world_size: 6.5)",
    "numAngles": 8,
    "tracks": {
      "stand:idle": {
        "sectionIndex": 0,
        "frameCount": 4,
        "fps": 4.0,
        "stance": "stand",
        "action": "idle",
        "description": "STAND IDLE"
      },
      "stand:walk": {
        "sectionIndex": 4,
        "frameCount": 8,
        "fps": 8.0,
        "stance": "stand",
        "action": "walk",
        "description": "STAND WALK"
      },
      "stand:run": {
        "sectionIndex": 12,
        "frameCount": 8,
        "fps": 10.0,
        "stance": "stand",
        "action": "run",
        "description": "STAND RUN"
      },
      "stand:attack": {
        "sectionIndex": 20,
        "frameCount": 7,
        "fps": 8.0,
        "stance": "stand",
        "action": "attack",
        "description": "STAND ATTACK"
      },
      "stand:hurt": {
        "sectionIndex": 27,
        "frameCount": 2,
        "fps": 6.0,
        "stance": "stand",
        "action": "hurt",
        "description": "STAND HURT"
      },
      "stand:death": {
        "sectionIndex": 84,
        "frameCount": 6,
        "fps": 6.0,
        "stance": "stand",
        "action": "death",
        "description": "STAND DEATH"
      },
      "crouch:idle": {
        "sectionIndex": 42,
        "frameCount": 1,
        "fps": 4.0,
        "stance": "crouch",
        "action": "idle",
        "description": "CROUCH IDLE"
      },
      "crouch:walk": {
        "sectionIndex": 43,
        "frameCount": 8,
        "fps": 8.0,
        "stance": "crouch",
        "action": "walk",
        "description": "CROUCH WALK"
      },
      "crouch:run": {
        "sectionIndex": 51,
        "frameCount": 5,
        "fps": 10.0,
        "stance": "crouch",
        "action": "run",
        "description": "CROUCH RUN"
      },
      "crouch:attack": {
        "sectionIndex": 35,
        "frameCount": 7,
        "fps": 8.0,
        "stance": "crouch",
        "action": "attack",
        "description": "CROUCH ATTACK"
      },
      "crouch:hurt": {
        "sectionIndex": 56,
        "frameCount": 2,
        "fps": 6.0,
        "stance": "crouch",
        "action": "hurt",
        "description": "CROUCH HURT"
      },
      "swim:walk": {
        "sectionIndex": 58,
        "frameCount": 6,
        "fps": 8.0,
        "stance": "swim",
        "action": "walk",
        "description": "SWIM WALK"
      },
      "swim:attack": {
        "sectionIndex": 64,
        "frameCount": 6,
        "fps": 8.0,
        "stance": "swim",
        "action": "attack",
        "description": "SWIM ATTACK"
      },
      "swim:hurt": {
        "sectionIndex": 70,
        "frameCount": 7,
        "fps": 6.0,
        "stance": "swim",
        "action": "hurt",
        "description": "SWIM HURT"
      },
      "swim:idle": {
        "sectionIndex": 77,
        "frameCount": 7,
        "fps": 4.0,
        "stance": "swim",
        "action": "idle",
        "description": "SWIM IDLE"
      }
    }
  },
  "raven4": {
    "id": "raven4",
    "name": "RAVEN-4 SHADOW CYBORG",
    "category": "CYBORG",
    "defaultEnvironment": "ground",
    "allowedEnvironments": [
      "ground",
      "water"
    ],
    "allowedStances": [
      "crouch",
      "stand",
      "swim"
    ],
    "worldSize": 6.5,
    "dimension": {
      "widthMeters": 0.99,
      "heightMeters": 1.17,
      "depthMeters": 0.2
    },
    "sourceTag": "ESOTERIA/SPRITES.E3 : raven4.e3 (world_size: 6.5)",
    "numAngles": 8,
    "tracks": {
      "stand:idle": {
        "sectionIndex": 0,
        "frameCount": 4,
        "fps": 4.0,
        "stance": "stand",
        "action": "idle",
        "description": "STAND IDLE"
      },
      "stand:walk": {
        "sectionIndex": 4,
        "frameCount": 8,
        "fps": 8.0,
        "stance": "stand",
        "action": "walk",
        "description": "STAND WALK"
      },
      "stand:run": {
        "sectionIndex": 12,
        "frameCount": 8,
        "fps": 10.0,
        "stance": "stand",
        "action": "run",
        "description": "STAND RUN"
      },
      "stand:attack": {
        "sectionIndex": 20,
        "frameCount": 7,
        "fps": 8.0,
        "stance": "stand",
        "action": "attack",
        "description": "STAND ATTACK"
      },
      "stand:hurt": {
        "sectionIndex": 27,
        "frameCount": 2,
        "fps": 6.0,
        "stance": "stand",
        "action": "hurt",
        "description": "STAND HURT"
      },
      "stand:death": {
        "sectionIndex": 84,
        "frameCount": 6,
        "fps": 6.0,
        "stance": "stand",
        "action": "death",
        "description": "STAND DEATH"
      },
      "crouch:idle": {
        "sectionIndex": 42,
        "frameCount": 1,
        "fps": 4.0,
        "stance": "crouch",
        "action": "idle",
        "description": "CROUCH IDLE"
      },
      "crouch:walk": {
        "sectionIndex": 43,
        "frameCount": 8,
        "fps": 8.0,
        "stance": "crouch",
        "action": "walk",
        "description": "CROUCH WALK"
      },
      "crouch:run": {
        "sectionIndex": 51,
        "frameCount": 5,
        "fps": 10.0,
        "stance": "crouch",
        "action": "run",
        "description": "CROUCH RUN"
      },
      "crouch:attack": {
        "sectionIndex": 35,
        "frameCount": 7,
        "fps": 8.0,
        "stance": "crouch",
        "action": "attack",
        "description": "CROUCH ATTACK"
      },
      "crouch:hurt": {
        "sectionIndex": 56,
        "frameCount": 2,
        "fps": 6.0,
        "stance": "crouch",
        "action": "hurt",
        "description": "CROUCH HURT"
      },
      "swim:walk": {
        "sectionIndex": 58,
        "frameCount": 6,
        "fps": 8.0,
        "stance": "swim",
        "action": "walk",
        "description": "SWIM WALK"
      },
      "swim:attack": {
        "sectionIndex": 64,
        "frameCount": 6,
        "fps": 8.0,
        "stance": "swim",
        "action": "attack",
        "description": "SWIM ATTACK"
      },
      "swim:hurt": {
        "sectionIndex": 70,
        "frameCount": 7,
        "fps": 6.0,
        "stance": "swim",
        "action": "hurt",
        "description": "SWIM HURT"
      },
      "swim:idle": {
        "sectionIndex": 77,
        "frameCount": 7,
        "fps": 4.0,
        "stance": "swim",
        "action": "idle",
        "description": "SWIM IDLE"
      }
    }
  },
  "riot": {
    "id": "riot",
    "name": "RIOT SUPPRESSION ENFORCER",
    "category": "CYBORG",
    "defaultEnvironment": "ground",
    "allowedEnvironments": [
      "ground"
    ],
    "allowedStances": [
      "stand"
    ],
    "worldSize": 6.5,
    "dimension": {
      "widthMeters": 0.99,
      "heightMeters": 1.17,
      "depthMeters": 0.2
    },
    "sourceTag": "ESOTERIA/SPRITES.E3 : riot.e3 (world_size: 6.5)",
    "numAngles": 8,
    "tracks": {
      "stand:idle": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 4.0,
        "stance": "stand",
        "action": "idle",
        "description": "STAND IDLE"
      },
      "stand:walk": {
        "sectionIndex": 1,
        "frameCount": 8,
        "fps": 8.0,
        "stance": "stand",
        "action": "walk",
        "description": "STAND WALK"
      },
      "stand:run": {
        "sectionIndex": 9,
        "frameCount": 8,
        "fps": 10.0,
        "stance": "stand",
        "action": "run",
        "description": "STAND RUN"
      },
      "stand:attack": {
        "sectionIndex": 17,
        "frameCount": 3,
        "fps": 8.0,
        "stance": "stand",
        "action": "attack",
        "description": "STAND ATTACK"
      },
      "stand:hurt": {
        "sectionIndex": 20,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "hurt",
        "description": "STAND HURT"
      },
      "stand:death": {
        "sectionIndex": 22,
        "frameCount": 2,
        "fps": 6.0,
        "stance": "stand",
        "action": "death",
        "description": "STAND DEATH"
      }
    }
  },
  "rival": {
    "id": "rival",
    "name": "RIVAL NEMESIS AGENT",
    "category": "CYBORG",
    "defaultEnvironment": "ground",
    "allowedEnvironments": [
      "ground"
    ],
    "allowedStances": [
      "stand"
    ],
    "worldSize": 8.0,
    "dimension": {
      "widthMeters": 1.22,
      "heightMeters": 1.44,
      "depthMeters": 0.2
    },
    "sourceTag": "ESOTERIA/SPRITES.E3 : rival.e3 (world_size: 8.0)",
    "numAngles": 8,
    "tracks": {
      "stand:idle": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 4.0,
        "stance": "stand",
        "action": "idle",
        "description": "STAND IDLE"
      },
      "stand:walk": {
        "sectionIndex": 1,
        "frameCount": 8,
        "fps": 8.0,
        "stance": "stand",
        "action": "walk",
        "description": "STAND WALK"
      },
      "stand:run": {
        "sectionIndex": 9,
        "frameCount": 6,
        "fps": 10.0,
        "stance": "stand",
        "action": "run",
        "description": "STAND RUN"
      },
      "stand:attack": {
        "sectionIndex": 15,
        "frameCount": 1,
        "fps": 8.0,
        "stance": "stand",
        "action": "attack",
        "description": "STAND ATTACK"
      },
      "stand:hurt": {
        "sectionIndex": 16,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "hurt",
        "description": "STAND HURT"
      },
      "stand:death": {
        "sectionIndex": 17,
        "frameCount": 6,
        "fps": 6.0,
        "stance": "stand",
        "action": "death",
        "description": "STAND DEATH"
      }
    }
  },
  "rivalmv1": {
    "id": "rivalmv1",
    "name": "RIVAL COMBAT STANCE ALPHA",
    "category": "INFANTRY",
    "defaultEnvironment": "ground",
    "allowedEnvironments": [
      "ground"
    ],
    "allowedStances": [
      "stand"
    ],
    "worldSize": 8.0,
    "dimension": {
      "widthMeters": 1.22,
      "heightMeters": 1.44,
      "depthMeters": 0.2
    },
    "sourceTag": "ESOTERIA/SPRITES.E3 : rivalmv1.e3 (world_size: 8.0)",
    "numAngles": 8,
    "tracks": {
      "stand:idle": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 4.0,
        "stance": "stand",
        "action": "idle",
        "description": "STAND IDLE"
      },
      "stand:walk": {
        "sectionIndex": 1,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "walk",
        "description": "STAND WALK"
      },
      "stand:attack": {
        "sectionIndex": 2,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "attack",
        "description": "STAND ATTACK"
      },
      "stand:hurt": {
        "sectionIndex": 3,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "hurt",
        "description": "STAND HURT"
      },
      "stand:death": {
        "sectionIndex": 4,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "death",
        "description": "STAND DEATH"
      }
    }
  },
  "rivalmv2": {
    "id": "rivalmv2",
    "name": "RIVAL COMBAT STANCE BETA",
    "category": "INFANTRY",
    "defaultEnvironment": "ground",
    "allowedEnvironments": [
      "ground"
    ],
    "allowedStances": [
      "stand"
    ],
    "worldSize": 8.0,
    "dimension": {
      "widthMeters": 1.22,
      "heightMeters": 1.44,
      "depthMeters": 0.2
    },
    "sourceTag": "ESOTERIA/SPRITES.E3 : rivalmv2.e3 (world_size: 8.0)",
    "numAngles": 8,
    "tracks": {
      "stand:idle": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 4.0,
        "stance": "stand",
        "action": "idle",
        "description": "STAND IDLE"
      },
      "stand:walk": {
        "sectionIndex": 1,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "walk",
        "description": "STAND WALK"
      },
      "stand:attack": {
        "sectionIndex": 2,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "attack",
        "description": "STAND ATTACK"
      },
      "stand:hurt": {
        "sectionIndex": 3,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "hurt",
        "description": "STAND HURT"
      },
      "stand:death": {
        "sectionIndex": 4,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "death",
        "description": "STAND DEATH"
      }
    }
  },
  "science": {
    "id": "science",
    "name": "FACILITY COMBAT SCIENTIST",
    "category": "INFANTRY",
    "defaultEnvironment": "ground",
    "allowedEnvironments": [
      "ground"
    ],
    "allowedStances": [
      "stand"
    ],
    "worldSize": 6.5,
    "dimension": {
      "widthMeters": 0.99,
      "heightMeters": 1.17,
      "depthMeters": 0.2
    },
    "sourceTag": "ESOTERIA/SPRITES.E3 : science.e3 (world_size: 6.5)",
    "numAngles": 8,
    "tracks": {
      "stand:idle": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 4.0,
        "stance": "stand",
        "action": "idle",
        "description": "STAND IDLE"
      },
      "stand:walk": {
        "sectionIndex": 1,
        "frameCount": 8,
        "fps": 8.0,
        "stance": "stand",
        "action": "walk",
        "description": "STAND WALK"
      },
      "stand:run": {
        "sectionIndex": 1,
        "frameCount": 8,
        "fps": 8.0,
        "stance": "stand",
        "action": "run",
        "description": "STAND RUN"
      },
      "stand:attack": {
        "sectionIndex": 9,
        "frameCount": 2,
        "fps": 8.0,
        "stance": "stand",
        "action": "attack",
        "description": "STAND ATTACK"
      },
      "stand:hurt": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 4.0,
        "stance": "stand",
        "action": "hurt",
        "description": "STAND HURT"
      },
      "stand:death": {
        "sectionIndex": 9,
        "frameCount": 2,
        "fps": 6.0,
        "stance": "stand",
        "action": "death",
        "description": "STAND DEATH"
      }
    }
  },
  "scubagun": {
    "id": "scubagun",
    "name": "AUTOMATED SUB-AQUATIC TURRET",
    "category": "AQUATIC",
    "defaultEnvironment": "water",
    "allowedEnvironments": [
      "water"
    ],
    "allowedStances": [
      "stand"
    ],
    "worldSize": 4.0,
    "dimension": {
      "widthMeters": 0.77,
      "heightMeters": 0.9,
      "depthMeters": 0.2
    },
    "sourceTag": "ESOTERIA/SPRITES.E3 : scubagun.e3 (world_size: 4.0)",
    "numAngles": 8,
    "tracks": {
      "stand:idle": {
        "sectionIndex": 0,
        "frameCount": 8,
        "fps": 4.0,
        "stance": "stand",
        "action": "idle",
        "description": "STAND IDLE"
      },
      "stand:walk": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "walk",
        "description": "STAND WALK"
      },
      "stand:run": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "run",
        "description": "STAND RUN"
      },
      "stand:attack": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "attack",
        "description": "STAND ATTACK"
      },
      "stand:hurt": {
        "sectionIndex": 0,
        "frameCount": 8,
        "fps": 4.0,
        "stance": "stand",
        "action": "hurt",
        "description": "STAND HURT"
      },
      "stand:death": {
        "sectionIndex": 0,
        "frameCount": 8,
        "fps": 6.0,
        "stance": "stand",
        "action": "death",
        "description": "STAND DEATH"
      }
    }
  },
  "seamon": {
    "id": "seamon",
    "name": "SEAMON AQUATIC BEAST",
    "category": "AQUATIC",
    "defaultEnvironment": "water",
    "allowedEnvironments": [
      "water"
    ],
    "allowedStances": [
      "stand"
    ],
    "worldSize": 5.0,
    "dimension": {
      "widthMeters": 0.77,
      "heightMeters": 0.9,
      "depthMeters": 0.2
    },
    "sourceTag": "ESOTERIA/SPRITES.E3 : seamon.e3 (world_size: 5.0)",
    "numAngles": 8,
    "tracks": {
      "stand:idle": {
        "sectionIndex": 0,
        "frameCount": 4,
        "fps": 4.0,
        "stance": "stand",
        "action": "idle",
        "description": "STAND IDLE"
      },
      "stand:walk": {
        "sectionIndex": 4,
        "frameCount": 8,
        "fps": 8.0,
        "stance": "stand",
        "action": "walk",
        "description": "STAND WALK"
      },
      "stand:run": {
        "sectionIndex": 4,
        "frameCount": 8,
        "fps": 8.0,
        "stance": "stand",
        "action": "run",
        "description": "STAND RUN"
      },
      "stand:attack": {
        "sectionIndex": 4,
        "frameCount": 8,
        "fps": 8.0,
        "stance": "stand",
        "action": "attack",
        "description": "STAND ATTACK"
      },
      "stand:hurt": {
        "sectionIndex": 0,
        "frameCount": 4,
        "fps": 4.0,
        "stance": "stand",
        "action": "hurt",
        "description": "STAND HURT"
      },
      "stand:death": {
        "sectionIndex": 4,
        "frameCount": 8,
        "fps": 6.0,
        "stance": "stand",
        "action": "death",
        "description": "STAND DEATH"
      }
    }
  },
  "sight": {
    "id": "sight",
    "name": "OPTICAL SNIPER TURRET",
    "category": "ROBOTIC",
    "defaultEnvironment": "ground",
    "allowedEnvironments": [
      "ground"
    ],
    "allowedStances": [
      "stand"
    ],
    "worldSize": 1.6640000343322754,
    "dimension": {
      "widthMeters": 0.77,
      "heightMeters": 0.9,
      "depthMeters": 0.2
    },
    "sourceTag": "ESOTERIA/SPRITES.E3 : sight.e3 (world_size: 1.6640000343322754)",
    "numAngles": 8,
    "tracks": {
      "stand:idle": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 4.0,
        "stance": "stand",
        "action": "idle",
        "description": "STAND IDLE"
      },
      "stand:walk": {
        "sectionIndex": 1,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "walk",
        "description": "STAND WALK"
      },
      "stand:attack": {
        "sectionIndex": 2,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "attack",
        "description": "STAND ATTACK"
      },
      "stand:hurt": {
        "sectionIndex": 3,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "hurt",
        "description": "STAND HURT"
      },
      "stand:death": {
        "sectionIndex": 4,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "death",
        "description": "STAND DEATH"
      }
    }
  },
  "spider": {
    "id": "spider",
    "name": "ARACHNID WALL SWARMER",
    "category": "INFANTRY",
    "defaultEnvironment": "ground",
    "allowedEnvironments": [
      "ground"
    ],
    "allowedStances": [
      "stand"
    ],
    "worldSize": 4.0,
    "dimension": {
      "widthMeters": 0.68,
      "heightMeters": 0.8,
      "depthMeters": 0.2
    },
    "sourceTag": "ESOTERIA/SPRITES.E3 : spider.e3 (world_size: 4.0)",
    "numAngles": 8,
    "tracks": {
      "stand:idle": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 4.0,
        "stance": "stand",
        "action": "idle",
        "description": "STAND IDLE"
      },
      "stand:walk": {
        "sectionIndex": 1,
        "frameCount": 8,
        "fps": 8.0,
        "stance": "stand",
        "action": "walk",
        "description": "STAND WALK"
      },
      "stand:run": {
        "sectionIndex": 1,
        "frameCount": 8,
        "fps": 8.0,
        "stance": "stand",
        "action": "run",
        "description": "STAND RUN"
      },
      "stand:attack": {
        "sectionIndex": 9,
        "frameCount": 2,
        "fps": 8.0,
        "stance": "stand",
        "action": "attack",
        "description": "STAND ATTACK"
      },
      "stand:hurt": {
        "sectionIndex": 11,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "hurt",
        "description": "STAND HURT"
      },
      "stand:death": {
        "sectionIndex": 11,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "death",
        "description": "STAND DEATH"
      }
    }
  },
  "tank": {
    "id": "tank",
    "name": "HEAVY ARMORED HOVER TANK",
    "category": "HEAVY",
    "defaultEnvironment": "ground",
    "allowedEnvironments": [
      "ground"
    ],
    "allowedStances": [
      "stand"
    ],
    "worldSize": 13.0,
    "dimension": {
      "widthMeters": 2.21,
      "heightMeters": 2.6,
      "depthMeters": 0.2
    },
    "sourceTag": "ESOTERIA/SPRITES.E3 : tank.e3 (world_size: 13.0)",
    "numAngles": 8,
    "tracks": {
      "stand:idle": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 4.0,
        "stance": "stand",
        "action": "idle",
        "description": "STAND IDLE"
      },
      "stand:walk": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "walk",
        "description": "STAND WALK"
      },
      "stand:run": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "run",
        "description": "STAND RUN"
      },
      "stand:attack": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "attack",
        "description": "STAND ATTACK"
      },
      "stand:hurt": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 4.0,
        "stance": "stand",
        "action": "hurt",
        "description": "STAND HURT"
      },
      "stand:death": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "death",
        "description": "STAND DEATH"
      }
    }
  },
  "trigbomb": {
    "id": "trigbomb",
    "name": "PROXIMITY DETONATION MINE",
    "category": "ROBOTIC",
    "defaultEnvironment": "ground",
    "allowedEnvironments": [
      "ground"
    ],
    "allowedStances": [
      "stand"
    ],
    "worldSize": 1.0,
    "dimension": {
      "widthMeters": 0.77,
      "heightMeters": 0.9,
      "depthMeters": 0.2
    },
    "sourceTag": "ESOTERIA/SPRITES.E3 : trigbomb.e3 (world_size: 1.0)",
    "numAngles": 8,
    "tracks": {
      "stand:idle": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 4.0,
        "stance": "stand",
        "action": "idle",
        "description": "STAND IDLE"
      },
      "stand:walk": {
        "sectionIndex": 1,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "walk",
        "description": "STAND WALK"
      },
      "stand:attack": {
        "sectionIndex": 2,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "attack",
        "description": "STAND ATTACK"
      },
      "stand:hurt": {
        "sectionIndex": 3,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "hurt",
        "description": "STAND HURT"
      },
      "stand:death": {
        "sectionIndex": 4,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "death",
        "description": "STAND DEATH"
      }
    }
  },
  "waterbot": {
    "id": "waterbot",
    "name": "WATERBOT SUBMERSIBLE DRONE",
    "category": "INFANTRY",
    "defaultEnvironment": "ground",
    "allowedEnvironments": [
      "ground"
    ],
    "allowedStances": [
      "stand"
    ],
    "worldSize": 10.0,
    "dimension": {
      "widthMeters": 1.27,
      "heightMeters": 1.5,
      "depthMeters": 0.2
    },
    "sourceTag": "ESOTERIA/SPRITES.E3 : waterbot.e3 (world_size: 10.0)",
    "numAngles": 8,
    "tracks": {
      "stand:idle": {
        "sectionIndex": 0,
        "frameCount": 1,
        "fps": 4.0,
        "stance": "stand",
        "action": "idle",
        "description": "STAND IDLE"
      },
      "stand:walk": {
        "sectionIndex": 1,
        "frameCount": 8,
        "fps": 8.0,
        "stance": "stand",
        "action": "walk",
        "description": "STAND WALK"
      },
      "stand:run": {
        "sectionIndex": 1,
        "frameCount": 8,
        "fps": 8.0,
        "stance": "stand",
        "action": "run",
        "description": "STAND RUN"
      },
      "stand:attack": {
        "sectionIndex": 9,
        "frameCount": 1,
        "fps": 8.0,
        "stance": "stand",
        "action": "attack",
        "description": "STAND ATTACK"
      },
      "stand:hurt": {
        "sectionIndex": 10,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "hurt",
        "description": "STAND HURT"
      },
      "stand:death": {
        "sectionIndex": 11,
        "frameCount": 1,
        "fps": 6.0,
        "stance": "stand",
        "action": "death",
        "description": "STAND DEATH"
      }
    }
  }
}
